import type { AppState } from '../stores';

export const getTravelLocationView = (state: AppState) => state.travelLocationView;

export const getUnits = (state: AppState) => {
  const data = state.travelLocationView.associated;
  if (data) {
    return data.units;
  }
  return null;
};
